import { BehaviorSubject } from 'rxjs';
import { ComponentSelectionStorageService } from '@sdbn/common';
import { SacStructure } from './sac-client.model';

export class SacClientContext {

    private componentSelectionStorageService: ComponentSelectionStorageService;

    triggerHighlightNewTransports = false;

    standaloneMode = false;

    showTransports = true;
    showStationUsageDetails = true;

    highlightNewTransports: boolean;
    notificationsEnabled: boolean;

    structures = new Array<SacStructure>();

    private widgetIdentifier_: string;

    public contextReady = new BehaviorSubject<void>(null);

    constructor(componentSelectionStorageService: ComponentSelectionStorageService) {
        this.componentSelectionStorageService = componentSelectionStorageService;
    }
    get widgetIdentifier() {
        return this.widgetIdentifier_;
    }
}
